module.exports = __webpack_public_path__ + "static/img/bg_attic.56192a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_attic.png
// module id = X8vS
// module chunks = 0